<template>
    <div class="row flex-column">
        <ui-breadcrumb title="Add Shortcode" :items="['Shortcodes', 'create']"></ui-breadcrumb>
        <div class="content">
            <div class="p-1">
                <form class="mb-5 mt-3" action="" method="POST" @submit.prevent="saveShortCode">
                    <div class="col-lg-10 col-xl-8 offset-lg-1 offset-xl-2">
                        <div class="row">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="sender-id">Access Code / Virtual Code</label>
                                    <input :class="{'is-invalid': formErrors.senderId}" id="sender-id" type="text"
                                           class="form-control"
                                           placeholder="Sender ID or Virtual Code" v-model="shortCode.senderId">
                                    <div v-if="formErrors.senderId" :class="['invalid-feedback']">
                                        {{formErrors.senderId[0]}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="sender-name">Sender Name / Alphanumeric</label>
                                    <input :class="{'is-invalid': formErrors.senderName}" type="text"
                                           class="form-control" v-model="shortCode.senderName" id="sender-name"
                                           placeholder="Short code or Alphanumeric">
                                    <div v-if="formErrors.senderName" :class="['invalid-feedback']">
                                        {{formErrors.senderName[0]}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="service-name">Service Name</label>
                                    <input :class="{'is-invalid': formErrors.serviceName}" type="text"
                                           class="form-control" v-model="shortCode.serviceName" id="service-name"
                                           placeholder="Service Name">
                                    <div v-if="formErrors.serviceName" :class="['invalid-feedback']">
                                        {{formErrors.serviceName[0]}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="service-id">Service</label>
                                    <input :class="{'is-invalid': formErrors.serviceId}" type="text"
                                           class="form-control" v-model="shortCode.serviceId" id="service-id"
                                           placeholder="Service ID">
                                    <div v-if="formErrors.serviceId" :class="['invalid-feedback']">
                                        {{formErrors.serviceId[0]}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="product-id">Product ID</label>
                                    <input v-model="shortCode.productId" type="text" class="form-control"
                                           id="product-id" placeholder="Product ID">
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="product-cost">Cost</label>
                                    <input :class="{'is-invalid': formErrors.cost}" v-model="shortCode.cost" type="text"
                                           class="form-control"
                                           id="product-cost" placeholder="Charges Per SMS">
                                    <div v-if="formErrors.cost" :class="['invalid-feedback']">
                                        {{formErrors.cost[0]}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="product-type">Service Type</label>
                                    <select :class="{'is-invalid': formErrors.type}" v-model="shortCode.type"
                                            class="form-control" id="product-type" placeholder="Product Type">
                                        <optgroup label="Product Types">
                                            <option v-for="(product, index) in smsProducts" :key="index"
                                                    :value="product.type">{{product.name}}
                                            </option>
                                        </optgroup>
                                    </select>
                                    <div v-if="formErrors.type" :class="['invalid-feedback']">
                                        {{formErrors.type[0]}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for="provider-network">Network Provider</label>
                                    <select :class="{'is-invalid': formErrors.network}" v-model="shortCode.network"
                                            class="form-control" id="provider-network" placeholder="Network">
                                        <optgroup label="SMS Providers">
                                            <option v-for="(provider, index) in smsProviders" :key="index"
                                                    :value="provider.name">
                                                {{provider.name}}
                                            </option>
                                        </optgroup>
                                    </select>
                                    <div v-if="formErrors.network" :class="['invalid-feedback']">
                                        {{formErrors.network[0]}}
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-12">
                                <div class="form-group">
                                    <label for="description">Description</label>
                                    <textarea rows="3" class="form-control form-control-alt"
                                              v-model="shortCode.description" id="description"></textarea>
                                </div>
                            </div>
                        </div>
                        <div class="float-right form-group">
                            <el-button icon="fa fa-check mr-2" type="success" :loading="loading" native-type="submit"
                                       :class="['btn', 'btn-hero-lg', 'btn-outline-success']">
                                Add Shortcode
                            </el-button>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import {APP_CONFIG} from '../../config';
    import {axios} from '../../bootstrap';

    export default {
        name: "OnBoardSenderCode",
        data() {
            return {
                loading: false,
                formErrors: [],
                smsProviders: [],
                smsProducts: [
                    {
                        name: 'Bulk SMS Service',
                        type: 'Bulk'
                    },
                    {
                        name: 'On Demand SMS Service',
                        type: 'OnDemand'
                    },
                    {
                        name: 'Subscription Service',
                        type: 'Premium'
                    }
                ],
                shortCode: {
                    network: '',
                    senderName: '',
                    senderId: '',
                    serviceId: '',
                    type: '',
                    cost: '',
                    serviceName: '',
                    productId: ''
                }
            };
        },
        mounted() {
            axios.get(APP_CONFIG.URL + 'sms/providers').then(response => {
                this.smsProviders = response.data.data.providers;
            });
        },
        methods: {
            saveShortCode() {
                this.formErrors = [];
                this.loading = true;
                axios.post(APP_CONFIG.URL + 'accounts/short-codes/create', this.shortCode).then(response => {
                    this.loading = true;
                    this.$notify({
                        type: 'success',
                        title: 'Short Code Created',
                        message: 'The short code service was created successfully',
                    });
                    this.$router.push('/services/short-codes');
                }).catch(error => {
                    this.loading = false;
                    if (error.response.status === 422) {
                        this.formErrors = error.response.data.errors;
                    }
                })
            }
        }
    }
</script>

<style scoped>

</style>
